module.exports = __webpack_public_path__ + "img/sequence-default.7b1a08b9.png";